import { render } from "./PlanViewConfiguration.vue?vue&type=template&id=81575068"
import script from "./PlanViewConfiguration.vue?vue&type=script&lang=js"
export * from "./PlanViewConfiguration.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__